import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";

import { capitalizeFirstLetter, formatNumberBasedOnUser, valueOrAlternative } from "../../utils/namesManipulation";
import { cn } from "../../utils/styling";
import { Building, Config } from "./types";

type AssetInfoProps = { building: Building; className?: string; config: Config; name?: string };

type Value = number | string | undefined;

export const AssetInfoRow = ({
  className,
  isNumeric = false,
  label,
  renderUnit,
  value,
}: {
  className?: string;
  isNumeric?: boolean;
  label: string;
  renderUnit?: (value: Value) => string;
  value?: Value;
}) => {
  return (
    <li className={cn("mb-4 pb-2 border-b-ds-softest", className)}>
      <h3 className="mb-1 uppercase text-lds-foreground-muted font-ds-label-sm">{label}</h3>
      <p className="font-ds-body-semibold-lg ">
        {isNumeric
          ? formatNumberBasedOnUser(valueOrAlternative(value))
          : capitalizeFirstLetter(String(valueOrAlternative(value)))}
        {renderUnit && <span>{renderUnit(value)}</span>}
      </p>
    </li>
  );
};

export const AssetInfo = ({ building, className, config, name }: AssetInfoProps) => {
  const { t } = useTranslation();

  if (!config?.length) return;

  const [leftCol, rightCol] = config;
  return (
    <div className={className}>
      <h2 className="sentence-case font-ds-headline-lg mt-8 ">{name}</h2>
      <Stack className="mt-6 items-start justify-between">
        {[leftCol, rightCol].map((col, i) => {
          return (
            <ul className="w-[47%]" key={i}>
              {col?.map((mapping, index) => {
                return (
                  <AssetInfoRow
                    isNumeric={mapping.isNumeric}
                    key={index}
                    label={t(`BuildingProfile.card.${mapping.label}`)}
                    renderUnit={mapping.renderUnit}
                    value={building[mapping.dataKey]}
                  />
                );
              })}
            </ul>
          );
        })}
      </Stack>
    </div>
  );
};
